import { lazyLoadView } from '@router/helpers';
export default [
  {
    path: '/i/:id(\\d+)/diklat',
    name: 'kelola-diklat',
    component: () => lazyLoadView(import('@views/instansi/diklat/list/base/Main')),
    meta: {
      title: 'Diklatku',
      tipe: 'daring',
    },
  },
  {
    path: '/i/:id(\\d+)/diklat-kelas/:diklat_id',
    name: 'diklat-kelas',
    component: () => lazyLoadView(import('@views/instansi/diklat/list/kelas/Index')),
    meta: {
      title: 'Kelola Diklat',
      tipe: 'daring',
    },
  },
  {
    path: '/i/:id(\\d+)/jadwal',
    name: 'kelola-jadwal',
    component: () => lazyLoadView(import('@views/instansi/diklat/list/jadwal/Index')),
    meta: {
      title: 'Kelola Jadwal Diklat',
      tipe: 'daring',
    },
  },
  {
    path: '/i/:id(\\d+)/diklat-luring',
    name: 'kelola-diklat-luring',
    component: () => lazyLoadView(import('@views/instansi/diklat/list/base/Main')),
    meta: {
      title: 'Diklatku',
      tipe: 'luring',
    },
  },
  {
    path: '/i/:id(\\d+)/diklat-kelas-luring/:diklat_id',
    name: 'diklat-kelas-luring',
    component: () => lazyLoadView(import('@views/instansi/diklat/list/kelas/Index')),
    meta: {
      title: 'Kelola Diklat',
      tipe: 'luring',
    },
  },
  {
    path: '/i/:id(\\d+)/jadwal-luring',
    name: 'kelola-jadwal-luring',
    component: () => lazyLoadView(import('@views/instansi/diklat/list/jadwal/Index')),
    meta: {
      title: 'Kelola Jadwal Diklat',
      tipe: 'luring',
    },
  },
  {
    path: '/i/:id(\\d+)/luring-sertifikat',
    name: 'luring-sertifikat',
    component: () => lazyLoadView(import('@views/instansi/diklat/list/sertifikat/Index')),
    meta: {
      title: 'Sertifikat Diklat',
      jenis: 'luring',
    },
  },
  {
    path: '/i/:id(\\d+)/luring-sertifikat-peserta/:kelas_id',
    name: 'luring-sertifikat-peserta',
    component: () => lazyLoadView(import('@views/instansi//diklat/list/sertifikat/Detail')),
    meta: {
      title: 'Sertifikat Diklat',
      jenis: 'luring',
    },
  },
  {
    path: '/i/:id(\\d+)/bcmp-sertifikat',
    name: 'bcmp-sertifikat',
    component: () => lazyLoadView(import('@views/instansi/diklat/list/sertifikat/Index')),
    meta: {
      title: 'Sertifikat Diklat',
      jenis: 'bcmp',
    },
  },
  {
    path: '/i/:id(\\d+)/bcmp-sertifikat-peserta/:kelas_id',
    name: 'bcmp-sertifikat-peserta',
    component: () => lazyLoadView(import('@views/instansi//diklat/list/sertifikat/Detail')),
    meta: {
      title: 'Sertifikat Diklat',
      jenis: 'bcmp',
    },
  },
  {
    path: '/i/:id(\\d+)/diklat-bcmp',
    name: 'kelola-diklat-bcmp',
    component: () => lazyLoadView(import('@views/instansi/diklat/list/base/Main')),
    meta: {
      title: 'Diklatku',
      tipe: 'bcmp',
    },
  },
  {
    path: '/i/:id(\\d+)/diklat-refreshment',
    name: 'kelola-diklat-refreshment',
    component: () => lazyLoadView(import('@views/instansi/diklat/list/base/Main')),
    meta: {
      title: 'Diklatku',
      tipe: 'refreshment',
    },
  },
  {
    path: '/i/:id(\\d+)/diklat-kelas-bcmp/:diklat_id',
    name: 'diklat-kelas-bcmp',
    component: () => lazyLoadView(import('@views/instansi/diklat/list/kelas/Index')),
    meta: {
      title: 'Kelola Diklat',
      tipe: 'bcmp',
    },
  },
  {
    path: '/i/:id(\\d+)/diklat-kelas-refreshment/:diklat_id',
    name: 'diklat-kelas-refreshment',
    component: () => lazyLoadView(import('@views/instansi/diklat/list/kelas/Index')),
    meta: {
      title: 'Kelola Diklat',
      tipe: 'refreshment',
    },
  },
  {
    path: '/i/:id(\\d+)/diklat-kelas-bcmp-detail/:diklat_id/kelas/:kelas_id',
    name: 'diklat-kelas-bcmp-detail',
    component: () => lazyLoadView(import('@views/instansi/diklat/list/kelas/Detail')),
    meta: {
      title: 'Detail Kelas',
      tipe: 'bcmp',
    },
  },
  {
    path: '/i/:id(\\d+)/diklat-kelas-refreshment-detail/:diklat_id/kelas/:kelas_id',
    name: 'diklat-kelas-refreshment-detail',
    component: () => lazyLoadView(import('@views/instansi/diklat/list/kelas/Detail')),
    meta: {
      title: 'Detail Kelas',
      tipe: 'refreshment',
    },
  },
  {
    path: '/i/:id(\\d+)/jadwal-bcmp',
    name: 'kelola-jadwal-bcmp',
    component: () => lazyLoadView(import('@views/instansi/diklat/list/jadwal/Index')),
    meta: {
      title: 'Kelola Jadwal Diklat',
      tipe: 'bcmp',
    },
  },
  {
    path: '/i/:id(\\d+)/bcmp-sertifikat',
    name: 'bcmp-sertifikat',
    component: () => lazyLoadView(import('@views/instansi/diklat/list/sertifikat/Index')),
    meta: {
      title: 'Sertifikat Diklat',
    },
  },
  {
    path: '/i/:id(\\d+)/bcmp-sertifikat-peserta/:kelas_id',
    name: 'bcmp-sertifikat-peserta',
    component: () => lazyLoadView(import('@views/instansi/diklat/list/sertifikat/Detail')),
    meta: {
      title: 'Sertifikat Diklat',
    },
  },
];
